import {IMessageData} from "../../index";
import * as ko from "knockout";
import {ICloneParams} from "../index";
import {nsFa} from "../../component/fa/fn";
import {isPartOf} from "../../util/misc";
import i = nsFa.i;
import copyHtml from './copy.html?raw';

export let template: string = copyHtml;

export class AbstractCrudBase {

    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);

    private _stepSubscriber: KnockoutSubscription;

    readonly Step = {};
    protected readonly STEP_ORDER: string[] = [];

    step: KnockoutObservable<string | null> = ko.observable(null);
    private readonly icon: string;

    constructor(protected params: ICloneParams) {
        this.icon = i(params.options.icon)
        this._stepSubscriber = this.step.subscribe(this.updateStep.bind(this));
    }

    protected updateStep() {
        // override this
    }

    protected process(): Promise<any> {
        // override this
        return Promise.resolve();
    }

    protected processSuccess(data: any[]) {
        // override this
    }

    protected processError(reason: string) {
        // override this
    }

    prevStepClick() {
        const step = this.step();
        if (!step) {
            return;
        }
        const index = this.STEP_ORDER.indexOf(step);
        const prev = this.STEP_ORDER[index - 1];
        if (prev) {
            this.step(prev);
        }
    }

    nextStepClick() {
        const step = this.step();
        if (!step) {
            return;
        }
        const index = this.STEP_ORDER.indexOf(step);
        const next = this.STEP_ORDER[index + 1];
        if (next) {
            this.step(next);
        }
    }

    protected isStep = isPartOf.bind(this, this.step)

    dispose() {
        this._stepSubscriber.dispose();
    }

}